export const NO_EVENTS = "emptyEvents";

export const UNAPPROVED_DJ_STATUS = "unapprovedDj";

export const PENDING_DJS = "pendingDjs";

export const APPROVED_DJS = "approvedDjs";

export const ONGOING_ONBOARDING_STATUS = "ongoingOnboarding";

export const COMPLETED_ONBOARDING_STATUS = "completedOnboarding";

export const ONGOING_ONBOARDING_STATUS_PERSONAL_ID_REQUIRED_STATUS =
  "personalIdRequired";

export const STEPS_TO_ADD_PERSONAL_ID = [
  "Go to Stripe Dashboard",
  "Go to profile icon on the top right",
  "Under Account Settings find Personal details",
  "Click on Edit",
  "Under ID Verification section click on Upload document",
  "Add your ID",
  "Click on Submit",
];

export const EMPTY_STATE_CONTENT = {
  [NO_EVENTS]: {
    emptyStateTitle: "No Events yet.",
    emptyStateSubtitle: "There are no active events related to you yet.",
  },
  [UNAPPROVED_DJ_STATUS]: {
    emptyStateTitle: "No Events yet.",
    emptyStateSubtitle:
      "Your DJ profile will be reviewed by a VIBY Music administrator. Once your account has been approved, you’ll be able to view your related events and connect your Stripe wallet through the Payments tab."
  },
  [ONGOING_ONBOARDING_STATUS]: {
    emptyStateTitle: "No Events yet.",
    emptyStateSubtitle:
      "Please add your wallet details to be able to see the events.",
    addWallet: "Add wallet ->",
  },
  [ONGOING_ONBOARDING_STATUS_PERSONAL_ID_REQUIRED_STATUS]: {
    emptyStateTitle: "Personal ID verification required.",
    emptyStateSubtitle:
      "Please add your personal ID from the Stripe dashboard to finish your wallet.",
  },
  [PENDING_DJS]: {
    emptyStatetitle: "",
    emptyStateSubtitle: "There are no DJs waiting for approval.",
  },
  [APPROVED_DJS]: {
    emptyStatetitle: "",
    emptyStateSubtitle: "There are no DJs yet.",
  },
};
